import React from "react";
import { AppConstants } from "../../../app/app-constants";
import HomeFooter from "../../home/presentation/home-footer";
import Card from "./card";
import { useTranslation } from "react-i18next";
const cards = AppConstants.cardsMap


export default function TarotCards() {
	const {t} = useTranslation()

  return (
    <>
      {/* <!--Tarot Start--> */}
			<div className="ast_tarot_wrapper ast_toppadder70 ast_bottompadder70">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="ast_heading">
								<h1>{t('the')} <span>{t('cards')}</span></h1>
								{/* <p>There are many vari ations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected hummer.</p> */}
							</div>
						</div>
						<div className="col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="ast_tarot_box_wrapper">
								<div className="row">
									{cards.map((el, i) => 
										<React.Fragment key={`card_tarot_${i}`}>
											<Card card={el}/>
										</React.Fragment>
									)}
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
										<div className="ast_btn">load more</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <!--Tarot End--> */}
    </>
  )
}